import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SedsAlertCoreComponent } from './seds-alert-core.component';

@NgModule({
  declarations: [SedsAlertCoreComponent],
  imports: [CommonModule, MatIconModule],
  exports: [SedsAlertCoreComponent],
})
export class SedsAlertCoreModule {}
